// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/elements/AlertTranslationApprove/alert.css
// module id = 1944
// module chunks = 193